import { resolveSnowplowConfig } from './config';
import {
  canTrackSnowplowPageLeave,
  getSnowplowDebugState,
  initSnowplowProvider,
  trackSnowplowProviderEvent,
} from './provider';

import type { SnowplowEventParams, SnowplowInitInput } from './types';

/**
 * 初始化 Snowplow，并在 local 环境暴露调试信息。
 * @param input - runtimeConfig 与魔方配置
 * @returns true 表示初始化成功并可发送事件
 */
export async function initSnowplow(input: SnowplowInitInput): Promise<boolean> {
  try {
    console.log('@snowplow--init', input);
    const config = resolveSnowplowConfig(input);
    const initialized = await initSnowplowProvider(config);
    if (config.debugEnabled) {
      window.__SNOWPLOW_DEBUG__ = {
        getState: getSnowplowDebugState,
      };
    }
    return initialized;
  } catch (error) {
    console.error('@snowplow--init', error);
    return false;
  }
}

/**
 * 旁路发送 Snowplow 事件。
 * @param eventName - 神策事件名
 * @param params - 过滤后的事件参数
 */
export function snowplowTrack(eventName: string, params: SnowplowEventParams = {}): void {
  try {
    trackSnowplowProviderEvent(eventName, params);
  } catch (error) {
    console.error('@snowplow--track', error);
  }
}

/**
 * 判断 Snowplow PageLeave 是否可以挂载。
 * @returns true 表示可以挂载 PageLeave
 */
export function isSnowplowPageLeaveEnabled(): boolean {
  return canTrackSnowplowPageLeave();
}
